import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
      </div>
      <div className="aurora-bg">
        <div className="aurora-orb aurora-orb-1"></div>
        <div className="aurora-orb aurora-orb-2"></div>
      </div>
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title fade-in-up">
              LYSEP <span className="highlight">CORPORATION</span>
            </h1>
            <p className="hero-subtitle fade-in-up">
              Yazılım alanında profesyonel çözümler sunuyoruz.
            </p>
            <div className="hero-buttons fade-in-up">
              <Link to="/about" className="btn">Keşfet</Link>
              <Link to="/contact" className="btn btn-outline">İletişime Geç</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
